namespace Solovis.Reports.StandardParts {

    export function getStandardPrintHeader() {
        return {
            partControl: "Solovis.Reports.Parts.SubReportControl",

            settings: {
                printOnly: true,

                reportOptions: function () {
                    var reportOptions = {
                        reportAlias: "StandardPrintHeader",
                        autoRun: true,
                        collapseConfigSection: true
                    };

                    return reportOptions;
                }
            }
        };
    }

    export function getResourcePropertiesBlock(options) {
        /// <summary>
        /// options should have resourceIdParametersPath which is string path to resource id with parameters.
        /// options.propertyReportElementName is optional, but needed for persisted settings or if there is
        /// more than one resource properties block on page.
        /// </summary>
        var resourceIdPath = options.resourceIdParametersPath;
        var propertyReportElementName = options.propertyReportElementName ? options.propertyReportElementName : "ResourcePropertiesReport";

        return {
            layout: "BlockWithHeader",

            header: {
                headerText: "Properties"
            },

            content: {
                elementName: propertyReportElementName,

                partControl: "Solovis.Reports.Parts.SubReportControl",

                settings: {
                    usePersistedSettings: true,

                    reportOptions: function () {
                        var resourcePropertyValuesReportCode = "C80F22A9-9924-4853-B91A-70A30D88D305";

                        var options = {
                            reportCode: resourcePropertyValuesReportCode,

                            parameters: {
                                resourceId: Solovis.resolveObject(resourceIdPath, this.parameters)
                            },

                            hiddenParameters: ["resourceId"],

                            autoRun: true,
                            collapseConfigSection: true
                        };

                        return options;
                    }
                }
            }
        };
    }


    export function getTabbedResourcePropertiesBlock(options) {
        /// <summary>
        /// options should have resourceIdParametersPath which is string path to resource id with parameters.
        /// options.propertyReportElementName is optional, but needed for persisted settings or if there is
        /// more than one resource properties block on page.
        /// </summary>
        var resourceIdPath = options.resourceIdParametersPath;
        var propertyReportElementName = options.propertyReportElementName ? options.propertyReportElementName : "TabbedResourcePropertiesReport";

        return {
            layout: "BlockWithHeader",

            header: {
                headerText: "Properties"
            },

            content: {
                elementName: propertyReportElementName,

                partControl: "Solovis.Reports.Parts.SubReportControl",

                settings: {
                    usePersistedSettings: true,

                    reportOptions: function () {
                        var tabbedResourcePropertyValuesReportCode = "476B9290-1132-4BE9-94FD-5EACA4921FAC";

                        var options = {
                            reportCode: tabbedResourcePropertyValuesReportCode,

                            parameters: {
                                resourceId: Solovis.resolveObject(resourceIdPath, this.parameters)
                            },

                            hiddenParameters: ["resourceId"],

                            autoRun: true,
                            collapseConfigSection: true
                        };

                        return options;
                    }
                }
            }
        };
    }

}
